import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-bastion-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="/bastion-logo.png"
                alt="Bastion Handwriting"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-bastion-gray-800 text-sm mb-4">
              Improve your handwriting with AI-powered analysis and custom practice worksheets.
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="https://www.facebook.com/bastionboltactionpen" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-700 hover:text-bastion-black transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://www.instagram.com/bastionboltactionpen" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-700 hover:text-bastion-black transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a href="https://x.com/bastionpens" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-700 hover:text-bastion-black transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.pinterest.com/bastionboltactionpen" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-700 hover:text-bastion-black transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/></svg>
              </a>
            </div>
          </div>

          {/* Worksheet Tools */}
          <div>
            <h3 className="font-semibold text-bastion-black uppercase text-sm tracking-bastion-wide mb-4">Worksheet Tools</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tools/cursive" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Cursive Handwriting
                </Link>
              </li>
              <li>
                <Link to="/tools/print" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Print Handwriting
                </Link>
              </li>
              <li>
                <Link to="/tools/name-tracing" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Name Tracing
                </Link>
              </li>
              <li>
                <Link to="/tools/alphabet-tracing" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Alphabet Tracing
                </Link>
              </li>
              <li>
                <Link to="/tools/number-tracing" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Number Tracing
                </Link>
              </li>
              <li>
                <Link to="/tools/tracing-lines" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Tracing Lines
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-bastion-black uppercase text-sm tracking-bastion-wide mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tools" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  All Tools
                </Link>
              </li>
              <li>
                <Link to="/analysis" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  AI Analysis
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>

          {/* Bastion Store */}
          <div>
            <h3 className="font-semibold text-bastion-black uppercase text-sm tracking-bastion-wide mb-4">Bastion Store</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://bastionboltactionpen.com" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors inline-flex items-center gap-1">
                  Shop Pens <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="https://bastionboltactionpen.com/pages/about-us" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  About Bastion
                </a>
              </li>
              <li>
                <a href="https://bastionboltactionpen.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://bastionboltactionpen.com/pages/contact-us" target="_blank" rel="noopener noreferrer" className="text-bastion-gray-800 hover:text-bastion-black text-sm transition-colors">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-bastion-gray-200 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-bastion-gray-700 text-sm">
            &copy; {new Date().getFullYear()} Bastion. All rights reserved.
          </p>
          <p className="text-bastion-gray-700 text-sm mt-2 md:mt-0">
            Crafted with quality, just like our pens.
          </p>
        </div>
      </div>
    </footer>
  );
}
